import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import DexAggregator from '../abis/DexAggregator';
import { getContractAddress } from '../constants/address';

export const getDexAggregator = ({
  chainId,
  publicClient,
  walletClient,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('DexAggregator', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: DexAggregator,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};

